<template>
  <div class="guide">
    <div class="avatar" :style="{ backgroundImage: `url(${avatarImg})` }"></div>

    <div class="info-box">
      <div class="title">身份信息</div>
      <div class="row">姓名：{{ userName }}</div>
      <div class="row">身份证号码：{{ idCardNo }}</div>
    </div>
    <div class="agree-box">
      <div class="small-title">
        为了满足合规要求，在使用人脸识别服务前，需要您授权其查询如下信息：
      </div>

      <ul class="ul-list">
        <li>查询您的人脸照片</li>
        <li>提供您的身份信息及录制的视频截图</li>
        <li>请允许使用手机摄像头</li>
      </ul>
    </div>

    <!-- <div class="agree-box">
      <div class="small-title">
        操作时请您配合
      </div>
      <ul class="ul-list">
        <li>请允许使用手机摄像头</li>
        <li>请调亮手机屏幕亮度，确保光线充足</li>
        <li>请保持正脸对准屏幕，确保人脸完整清晰</li>
        <li>请确保真实本人操作</li>
      </ul>
    </div> -->

    <div class="footer-box">
      <van-button type="primary" block :disabled="disabled" @click="startOfVerification">
        同意并验证
      </van-button>
    </div>
  </div>
</template>
<script>
import avatarImg from '@/assets/imgs/face_avatar.png'
import Api from '@/api'

/**
 * code码说明:
 * 由姓名和身份证号码组成,中间由英文字符,分割: 如: 张三,1232323232323, 组合成一个字符串
 * 把组合得到的字符串使用encodeURIComponent进行编码, 在使用window.btoa进行base64编码
 */

export default {
  components: {},
  data() {
    return {
      disabled: true,
      avatarImg,
      taskId: '',
      userName: '',
      idCardNo: '',
    }
  },
  created() {
    this.decode()
  },
  mounted() {
    this.checkTaskId()
  },
  methods: {
    decode() {
      console.log('decode: ', this.$route.query)
      // 从url获取code参数
      const { taskId, idCardNo, userName } = this.$route.query
      this.taskId = taskId
      this.userName = decodeURIComponent(userName)
      this.idCardNo = decodeURIComponent(idCardNo)
    },

    // 检测taskId
    checkTaskId() {
      if (this.taskId) {
        Api.getLivenessVerifyTaskStatus({
          taskId: this.taskId
        }).then(res => {
          this.disabled = false
        })
      } else {
        this.$toast('参数错误')
        return true
      }
    },

    // 开始验证
    startOfVerification() {
      if (!this.taskId) {
        this.$toast('参数错误')
        return
      }
      // 验证设置是否支持getUserMedia和MediaRecorder
      // 如果不支持则跳转到不支持页面
      if (
        !navigator.mediaDevices ||
        !navigator.mediaDevices.getUserMedia ||
        !window.MediaRecorder
      ) {
        this.$toast('当前设备不支持')
        // this.$router.push('/authentication/face/faceSecond')
      } else {
        const { idCardNo, userName, ...args } = this.$route.query
        this.$router.push({
          path: '/authentication/face/face_webrtc',
          query: args,
        })
      }

    },
  },
}
</script>

<style lang="less" scoped>
.guide {
  display: table;
}

.avatar {
  width: 130px;
  height: 130px;
  margin: 0 auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  border: 2px double #1676ff;
  margin-top: 60px;
}

.info-box {
  margin: 24px;
  border-radius: 8px;
  font-size: 14px;
  background-color: #f8f8f8;
  padding: 12px;

  .title {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 8px;
    color: #111a34;
  }

  .row {
    line-height: 1.8em;
    color: #677283;
    font-weight: 500;
  }
}

.agree-box {
  margin: 24px;

  .small-title {
    font-size: 12px;
    color: #677283;
    font-weight: 500;
    line-height: 1.5em;
    margin-bottom: 4px;
  }

  .ul-list {
    li {
      font-size: 12px;
      font-weight: 400;
      display: flex;
      align-items: center;
      color: #677283;
      line-height: 1.8em;
    }

    li::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      background: #1676ff;
      border-radius: 50%;
      margin-right: 0.4em;
    }
  }
}

.footer-box {
  background-color: #fff;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 8px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 8px);
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
}
</style>
